import React from 'react';
import { useImageAlt } from '../../../../hooks/useImageAlt';
import { Apartment } from '../../../../graphql/graphql';
import { ApartmentContainer, ApartmentImage } from './styled';
import { ApartmentFilterInfo } from './ApartmentFilterInfo';

interface ApartmentFilterCardProps {
  item: Apartment;
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectedId: React.Dispatch<React.SetStateAction<null | string>>;
  imgDescription: string;
}

export const ApartmentFilterCard: React.FC<ApartmentFilterCardProps> = ({
  item,
  setIsModalOpen,
  setSelectedId,
  imgDescription
}) => {
  const validPhoto = item.photos?.find(photo => photo?.f660x496);
  const hasImage = !!validPhoto;

  const onItemClick = () => {
    setIsModalOpen(true);
    setSelectedId(item.id);
  };

  const imgAlt = useImageAlt({
    rooms: item.rooms,
    area: item.area,
    description: imgDescription
  });

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onItemClick();
    }
  };

  const apartmentImage =
    validPhoto?.f660x496 ||
    '/static/images/residences/infrastructure-placeholder.png';

  return (
    <ApartmentContainer
      onClick={hasImage ? onItemClick : undefined}
      onKeyDown={hasImage ? handleKeyDown : undefined}
      tabIndex={hasImage ? 0 : -1}
      role="button"
      aria-disabled={!hasImage}
      key={item.id}
      data-cy="apartment-card"
      $hasImage={hasImage}
    >
      <ApartmentFilterInfo item={item} />

      <ApartmentImage
        width={60}
        height={60}
        src={apartmentImage}
        alt={imgAlt}
        $hasImage={hasImage}
      />
    </ApartmentContainer>
  );
};
